import {combineReducers} from "redux";
import {firebaseReducer} from "react-redux-firebase";
import {firestoreReducer} from "redux-firestore";

export const ProcessReducer = (state = {}, action) => {
    switch (action.type) {
      //returns updated state
      case "PROCESS":
        return { ...action.payload };
      //else the current state is retained
      default:
        return state;
    }
};

export const rootReducer = combineReducers({
    firebase: firebaseReducer,
    firestore: firestoreReducer,
    ProcessReducer: ProcessReducer
});